<pg-units>
  <section id="pg-units">
    <div class="section-container">
      <header>
        <h1>Unidades</h1>
      </header>
      <div class="units-list physical-units">
        <div class="units-grid">
          <div class="unit" each={ item in physicalUnits } }>
            <h3>{ item.city }</h3>
            <a href="tel://{item.phone}" class="phone">{ item.phone }</a>
            <p class="address">{ item.adresses }</p>
          </div>
        </div>
      </div>
      <div class="units-list virtual-units" if={virtualUnits.length > 0}>
        <div class="subtitle">Futuras Instalações:</div>
        <div class="units-grid">
          <div class="unit" each={ item in virtualUnits } }>
            <h3>{ item.city }</h3>
            <a href="tel://{item.phone}" class="phone">{ item.phone }</a>
          </div>
        </div>
      </div>
      <div class="units-map">
        <div class="bg"></div>
        <map-vector />
      </div>
    </div>
  </section>

  <script>
    import './pg-units.scss'
    import { locations } from '../components/locations.js'
    import MapVector from '../components/map-vector.riot'

    export default {
      components: {
        MapVector
      },
      physicalUnits: locations.filter(each => each.adresses != '' && each),
      virtualUnits: locations.filter(each => each.adresses == '' && each),
      onMounted() {
        document.querySelector('#footer-units').style.display = 'none'
        this.breakLines()
      },
      onUnmounted() {
        document.querySelector('#footer-units').style.display = 'inherit'
      },
      breakLines() {
        this.$$('.address').forEach( x => {
          x.innerHTML = x.innerText
        })
      }
    }
  </script>

</pg-units>
